import React from 'react'
import cn from 'classnames'
import styles from './HeroGuardians.module.sass'
import ScrollButton from '../../../shared/ScrollButton'
import Image from '../../Image'
import ScrollParallax from '../../ScrollParallax'
import Link from 'next/link'

export const HeroGuardians = () => {
  const launchChat = () => {
    // @ts-ignore
    // window.$crisp.push(['do', 'chat:open'])
    // window.$crisp.push(['do', 'message:send', ['text', "Hi! I'd like become a Guardian"]])
  }

  return (
    <div className={styles.hero}>
      <div className={cn('container', styles.container)}>
        <div className={styles.wrap}>
          <div className={cn('stage', styles.stage)}>Connect, guide and earn</div>
          <h1 className={cn('h1', styles.title)}>Earn money for helping developers</h1>
          <div className={styles.text}>
            We are a network of experienced developers. We devote our time to guiding developers in
            their technical challenges.
          </div>
          <div className={styles.btns}>
            <Link href="/api/auth/signin?callbackUrl=/app/onboarding">
              <a className={cn('button', styles.button)}>I'm ready to earn</a>
            </Link>
          </div>
        </div>
        <ScrollButton
          onScroll={() => (window.location.href = '#next')}
          className={styles.scrollbtn}
        />
        <div className={styles.gallery}>
          <div className={styles.preview}>
            <ScrollParallax animateIn="fadeInUp" delay={0}>
              <Image
                srcSet="img/hero-users-computers@2x.png 2x"
                src="img/hero-users-computers@1.5x.png"
                alt="Jungle Program Users"
              />
            </ScrollParallax>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroGuardians
